import React from "react";
import { MonitoringData } from "../../../../store/common";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import { useTranslation } from "react-i18next";

const CreditBureauInformation: React.FunctionComponent<{ monitoringData: MonitoringData }> = (props) => {
    const personalInformation = props.monitoringData && props.monitoringData.asset.personalInformation ? props.monitoringData.asset.personalInformation : {};
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const { t: tLang } = useTranslation();

    return (
        <div className={"box offset-padding"}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <em className="la la-cc-mastercard"></em>
                    </div>
                    <div className="box-title-text">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.businessCreditBureau.title")}</h2>
                    </div>
                </div>
            </div>
            <div id="business-credit-bureau" className="box-content">
                <div role="grid" className="data-grid has-lines row-height-md margin-top-l">
                    <div role="row" className="data-row row ">
                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                            <div className="data-label" id="label-business-credit-bureau">
                                {tLang("identityVault.monitoredInformation.businessCreditBureau.label.creditBureau")}
                            </div>
                        </div>
                        <div role="gridcell" className="col-xs-11 col-sm-6 col-no-gutter">
                            <div className="data-value has-gfx" aria-labelledby="label-business-credit-bureau">
                                {creditProvider === "CREDITSAFE"
                                    ? `${tLang("identityVault.monitoredInformation.businessCreditBureau.label.creditsafe")} - ` +
                                      (personalInformation ? personalInformation["business-credit-safe-number"] : "")
                                    : "Dun & Bradstreet - " + (personalInformation ? personalInformation["business-duns-number"] : "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreditBureauInformation;
